export default __webpack_public_path__ + "static/media/IT.87d3366b.svg";